import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=75ca642b&scoped=true&"
import script from "./Security.vue?vue&type=script&lang=ts&"
export * from "./Security.vue?vue&type=script&lang=ts&"
import style0 from "./Security.vue?vue&type=style&index=0&id=75ca642b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ca642b",
  null
  
)

export default component.exports